import React from "react";
//import PropTypes from "prop-types";
import FormControlLabel from '@material-ui/core/FormControlLabel';
//import Checkbox from '@material-ui/core/Checkbox';
import Switch from '@material-ui/core/Switch';

import TermItem from "./termItem";

class Term extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: this.props.checked
    };
   // this.handleInputChange = this.handleInputChange.bind(this);
  }

  handleInputChange = (event) => {
    const target = event.target;
    this.setState((state, props) => {
      return { 'checked': target.checked };
    });
    this.props.callback({ id: target.id, checked: target.checked });
  };
 
  render() {
    return (
      <div className="list-group">
        <div className=" list-group-item list-group-item-action flex-column align-items-start list-group-item-primary">
          <div className="d-flex w-100 justify-content-between align-items-center ">
            <h6 className="mb-1">{this.props.title}</h6>
          </div>
        </div>
        <div className="list-group text-left">
          {this.props.items.map((c, index) => <TermItem key={index.toString()} text={c.text} />)}
        </div>
        <div className="mt-1"></div>
          <div className="card aaborder-primary mb-3 aacard-header text-left">
              <FormControlLabel className="ml-2"
                control={
                  <Switch
                    id={this.props.id} 
                    checked={this.state.checked}
                    onChange={this.handleInputChange}
                    name="checkCommitment"
                    color="primary"
                  />
                }
          label="Yes, I Agree."
        />
      </div>
        <div className="mt-3"></div>
      </div>
    );
  }
}

export default Term;


//<label>Yes, I Agree:&nbsp;&nbsp;<input name="checkCommitment" id={this.props.id} checked={this.state.checked} onChange={this.handleInputChange} type="checkbox"></input> </label>

